<div class="root-container" (click)="onClick.emit(text())">
  <i class="bi bi-x-circle"></i>

  <span class="text">{{ text() }}</span>
</div>
